import styled from 'styled-components';

import { Flex, VFlex } from '@/components/base';
import Button from '@/components/Button/Button';
import Heading from '@/components/Typography/Heading';
import StaticSearchFilterDisplay from '@/features/GlobalSearch/components/StaticSearchFilterDisplay/StaticSearchFilterDisplay';
import type { TOPIC_2_TYPE } from '@/types/taxonomyConst';

import type { EditTopicModalProps } from '../types';

const SavedTopicSetting = (
  props: EditTopicModalProps & {
    initialTopic: Topic2T<TOPIC_2_TYPE.SAVED_TOPIC>;
    closeModal: () => void;
  },
) => {
  return (
    <Style g={32}>
      <Heading type="h3">Saved topic settings</Heading>
      <StaticSearchFilterDisplay
        title={props.initialTopic.name}
        desc={props.initialTopic.desc}
        saved_rule={props.initialTopic.saved_rule}
      />
      <Flex j="flex-end" g={16}>
        <Button
          variant="outlined"
          sizeType="l"
          onClick={() => {
            props.closeModal();
          }}
        >
          Done
        </Button>
      </Flex>
    </Style>
  );
};

const Style = styled(VFlex)`
  background-color: ${({ theme }) => theme.colors.gray100};
  width: 600px;
  border-radius: 16px;
  border: 1px solid ${({ theme }) => theme.colors.gray300};
  padding: 32px 24px;
`;

export default SavedTopicSetting;
